import { Component, signal } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'ltc-root',
  imports: [
    RippleModule,
    RouterOutlet,
    ToastModule,
    RouterLink,
    DrawerModule,
    ButtonModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  isSidebarOpen = signal(false);
  openSidebar(): void {
    this.isSidebarOpen.set(true);
  }
  closeSidebar(): void {
    setTimeout(() => {
      this.isSidebarOpen.set(false);
    });
  }
}
